// keep common family flow parts in this file
import { queryClient } from "@/lib/react-query-client";
import type { ExtendedUser } from "@/types/next-auth";

import type { FunnelData } from "../config.types";

export const isFamilyDirectToLssFlow = ({
  answers,
  experiments,
}: Omit<FunnelData, "meta" | "getExperiment">) => {
  const { subPractice } = answers || {};
  const { abTestDivorceFlowEnabled } = experiments || {};

  return !!abTestDivorceFlowEnabled && subPractice === "divorce";
};

export function hasCompletedIntakeQuestionnaire() {
  const user = queryClient.getQueryData<ExtendedUser>(["user"]);
  return user?.status === "intake_completed_with_questionnaire";
}
